import React, {useState, useEffect} from 'react'
import { ButtonGroup, ToggleButton, Carousel } from 'react-bootstrap'
import * as moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { sendErrorNotification } from '../../../../universal/notifications/notifications'
import { ToastContainer } from 'react-toastify'
import { changePipelineModal, requestAddSingleOpportunity } from '../../../../../redux/actions/pipeline'
import CompanyUnitDetails from './company-unit-details'
import PersonUnitDetails from './person-unit-details'
import { TransparentButton, SolidButton } from '../../../../library/button'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const modalState = useSelector(state => state.pipeline.showModals.addUnitPipelineModal)

	const searchError = useSelector(state => state.pipeline.search.error)
	const searchLoading = useSelector(state => state.pipeline.search.loading)

	const addLoading = useSelector(state => state.pipeline.addUnit.loading)

	const searchResults = useSelector(state => state.pipeline.search.status)
	const companyId = useSelector(state => state.activeCompany.activeCompany.id)
	const owner = useSelector(state => state.user.details.id)

	const pipelineId = useSelector(state => state.pipeline.activePipeline && state.pipeline.activePipeline.id)
	const units = useSelector(state => state.pipeline.activePipeline && state.pipeline.activePipeline.units)

	const [selection, setSelection] = useState("company")

	const [searchOrganizationNumber, setSearchOrganizationNumber] = useState("")

	const [companyOpportunity, setCompanyOpportunity] = useState({
		name: null,
		title: null,
		amount: null,
		unit: null,
		description: null,
		contactPerson: null,
		type: "company",
	})

	const [personOpportunity, setPersonOpportunity] = useState({
		firstName: null,
		lastName: null,
		title: null,
		amount: null,
		unit: null,
		description: null,
		type: "person",
	})

	const [activeOpportunityObject, setActiveOpportunityObject] = useState({
		name: null,
		title: null,
		amount: null,
		unit: null,
		description: null,
		contactPerson: null
	})

    const handleClose = () => {
		dispatch(changePipelineModal({addUnitPipelineModal: false}))
	}
		
    const clickAddNewOpportunity = () => {
		if(selection === "person"){
			if(personOpportunity.firstName && personOpportunity.lastName && personOpportunity.title && personOpportunity.amount && personOpportunity.unit){
				dispatch(requestAddSingleOpportunity({details: personOpportunity, companyId: companyId, organizationNumber: searchOrganizationNumber, pipelineId: pipelineId}))
			} else {
				sendErrorNotification("Vennligst fyll inn fornavn, etternavn, tittel, beløp og fase.")
			}
		} else if(selection === "company"){
			if(companyOpportunity.name && companyOpportunity.title && companyOpportunity.amount && companyOpportunity.unit){
				dispatch(requestAddSingleOpportunity({details: companyOpportunity, companyId: companyId, organizationNumber: searchOrganizationNumber, pipelineId: pipelineId}))
			} else {
				sendErrorNotification("Vennligst fyll inn bedriftsnavn, tittel, beløp og fase.")
			}
		}
	}
	
	useEffect(() => {
		if(searchError){
			sendErrorNotification("Kunne ikke hente kundeinformasjon.")
		}

		if(searchResults && Object.keys(searchResults).length > 0){

			const company = {}

			company["addedBy"] = owner
			company["timestamp"] = moment(Date.now()).unix()

			if(searchResults && searchResults.name){
				company["name"] = searchResults.name
			} else {
				company["name"] = null
			}

			if(searchResults && searchResults.organizationNumber){
				company["organizationNumber"] = searchResults.organizationNumber
			} else {
				company["organizationNumber"] = null
			}


			setActiveOpportunityObject(company)
		}

	}, [searchError, searchResults])

	return(
		<Popup
			onClose={handleClose}
			show={modalState} 
			title="Legg til ny mulighet"
            description="Velg hvilke type kunde du ønsker å legge inn en ny mulighet på ved å bruke de to knappene nedenfor."
			buttons={[
				<TransparentButton title="Avbryt" id="closeButtonAdd" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				<SolidButton color="blue" title={addLoading ? "Legger til..":"Legg til"} icon={addLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-plus"></i>} onClick={() => clickAddNewOpportunity()} type="button"/>
			]}
		>
			<div className="add-unit-content-container">
				<ButtonGroup className="selection-group" toggle>
					<ToggleButton className="single-selection" type="checkbox" checked={selection === "company" ? true:false} value="0" onChange={() => setSelection("company")}>
						Bedrift
					</ToggleButton>
					<ToggleButton className="single-selection" type="checkbox" checked={selection === "person" ? true:false} value="1" onChange={() => setSelection("person")}>
						Person
					</ToggleButton>
				</ButtonGroup>
				<Carousel activeIndex={selection === "person" ? 1:0} indicators={false} controls={false}>
					<Carousel.Item className="selection-item">
						<CompanyUnitDetails companyOpportunity={companyOpportunity} setCompanyOpportunity={setCompanyOpportunity}/>
					</Carousel.Item>
					<Carousel.Item className="selection-item">
						<PersonUnitDetails personOpportunity={personOpportunity} setPersonOpportunity={setPersonOpportunity}/>
					</Carousel.Item>
				</Carousel>
			</div>
			<ToastContainer/>
		</Popup>
	)
}

export default Index

